"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _core = require("@material-ui/core");
var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));
var _ArrowDropUp = _interopRequireDefault(require("@material-ui/icons/ArrowDropUp"));
var _Button = _interopRequireDefault(require("../Button"));
var _MenuItem = _interopRequireDefault(require("../MenuItem"));
var _Menu = _interopRequireDefault(require("../Menu"));
var _excluded = ["label", "onClick"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var getBoxShadow = function getBoxShadow(color) {
    return {
      '&:focus': {
        '-webkit-box-shadow': "inset 0 0 0 4px ".concat(color),
        'box-shadow': "inset 0 0 0 4px ".concat(color)
      }
    };
  };
  return {
    buttonRoot: _objectSpread({}, getBoxShadow(theme.palette.opacity.primary[800][38])),
    containedOk: {
      '&:not(:last-child)': {
        borderColor: theme.palette.accent.greenMain
      }
    },
    outlinedOk: _objectSpread({
      '&:hover': {
        borderColor: theme.palette.accent.greenMain
      }
    }, getBoxShadow(theme.palette.opacity.ok[500][38])),
    primaryButtonContained: _objectSpread({
      '&:not(:last-child)': {
        borderRight: '1px solid white'
      }
    }, getBoxShadow(theme.palette.opacity.white[38])),
    primaryButtonContainedDisabled: _objectSpread({
      '&:not(:last-child):disabled': {
        borderRight: '1px solid white'
      }
    }, getBoxShadow(theme.palette.opacity.white[38])),
    primaryButtonSizeMedium: {
      minWidth: '88px',
      padding: theme.spacing(0, 2)
    },
    primaryButtonSizeMediumWithIcon: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(2)
    },
    primaryButtonSizeSmall: {
      minWidth: '73px',
      padding: theme.spacing(0, 1)
    },
    secondaryButtonSizeMedium: {
      height: theme.spacing(4.5),
      minHeight: theme.spacing(4.5),
      minWidth: theme.spacing(4.5),
      width: theme.spacing(4.5)
    },
    secondaryButtonSizeSmall: {
      height: theme.spacing(4),
      minHeight: theme.spacing(4),
      minWidth: theme.spacing(4),
      width: theme.spacing(4)
    }
  };
});

// Can't put this in `defaultProps`, because when a user provides a prop
// for ButtonGroupProps, it overwrites all of the other defaults.
var defaultButtonGroupProps = {
  'aria-label': 'split button',
  color: 'primary',
  disabled: false,
  disableElevation: false,
  disableFocusRipple: true,
  disableRipple: true,
  fullWidth: false,
  orientation: 'horizontal',
  size: 'small',
  variant: 'contained'
};
var defaultSecondaryButtonAriaProps = {
  'aria-controls': 'split-button-menu',
  'aria-expanded': true,
  'aria-haspopup': 'menu',
  'aria-label': 'select alternative action'
};
var defaultDropdownIconsProps = {
  closed: /*#__PURE__*/_react["default"].createElement(_ArrowDropDown["default"], null),
  open: /*#__PURE__*/_react["default"].createElement(_ArrowDropUp["default"], null)
};
var defaultMenuProps = {
  alignment: 'left'
};
var defaultProps = {
  dataMetrics: {
    root: 'fuse_split_button'
  }
};

/**
 * SplitButton is a hybrid of a ButtonGroup and Menu. It's primary purpose
 * is to display a default action and include less frequently used variants of
 * the action in the dropdown menu.
 */
var SplitButton = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _cx3, _cx4;
  var ButtonGroupProps = props.ButtonGroupProps,
    dataMetrics = props.dataMetrics,
    dropdownIcons = props.dropdownIcons,
    menuItems = props.menuItems,
    MenuProps = props.MenuProps,
    primaryButtonProps = props.primaryButtonProps,
    secondaryButtonAriaProps = props.secondaryButtonAriaProps,
    status = props.status;
  var styles = useStyles();
  var mergedButtonGroupProps = _objectSpread({}, defaultButtonGroupProps, {}, ButtonGroupProps);
  var size = mergedButtonGroupProps.size,
    variant = mergedButtonGroupProps.variant;
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var mergedPrimaryButtonProps = _objectSpread({
    'aria-label': 'select default option'
  }, primaryButtonProps, {
    variant: variant
  });
  var mergedSecondaryButtonAriaProps = _objectSpread({}, defaultSecondaryButtonAriaProps, {}, secondaryButtonAriaProps);
  var mergedDropdownIcons = _objectSpread({}, defaultDropdownIconsProps, {}, dropdownIcons);
  var mergedMenuProps = _objectSpread({}, defaultMenuProps, {}, MenuProps);
  var primaryButtonRef = _react["default"].useRef(null);
  var secondaryButtonRef = _react["default"].useRef(null);
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  var menuOpen = anchorEl !== null;
  var handleMenuOpen = function handleMenuOpen(event) {
    setAnchorEl(event.currentTarget);
  };
  var handleMenuClose = function handleMenuClose() {
    setAnchorEl(null);
  };
  var handleMenuItemClick = function handleMenuItemClick(callback) {
    handleMenuClose();
    callback();
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, (0, _extends2["default"])({
    classes: {
      grouped: styles.buttonRoot,
      groupedContainedHorizontal: styles.primaryButtonContainedDisabled,
      groupedContainedPrimary: (0, _classnames["default"])(styles.primaryButtonContained, (0, _defineProperty2["default"])({}, styles.containedOk, status === 'ok')),
      groupedOutlined: (0, _classnames["default"])((0, _defineProperty2["default"])({}, styles.outlinedOk, status === 'ok'))
    },
    "data-metrics": mergedDataMetrics.root,
    ref: ref
  }, mergedButtonGroupProps), /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, mergedPrimaryButtonProps, {
    className: (0, _classnames["default"])((_cx3 = {}, (0, _defineProperty2["default"])(_cx3, styles.primaryButtonSizeMedium, size === 'medium' && !primaryButtonProps.icon), (0, _defineProperty2["default"])(_cx3, styles.primaryButtonSizeMediumWithIcon, size === 'medium' && primaryButtonProps.icon), (0, _defineProperty2["default"])(_cx3, styles.primaryButtonSizeSmall, size === 'small'), _cx3)),
    ref: primaryButtonRef,
    status: status,
    onKeyUp: function onKeyUp(event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        secondaryButtonRef.current.focus();
      }
    },
    size: size
  })), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    "aria-controls": menuOpen ? mergedSecondaryButtonAriaProps['aria-controls'] : undefined,
    "aria-expanded": menuOpen ? mergedSecondaryButtonAriaProps['aria-expanded'] : undefined,
    "aria-haspopup": mergedSecondaryButtonAriaProps['aria-haspopup'],
    "aria-label": mergedSecondaryButtonAriaProps['aria-label'],
    className: (0, _classnames["default"])((_cx4 = {}, (0, _defineProperty2["default"])(_cx4, styles.secondaryButtonSizeMedium, size === 'medium'), (0, _defineProperty2["default"])(_cx4, styles.secondaryButtonSizeSmall, size === 'small'), _cx4)),
    ref: secondaryButtonRef,
    status: status,
    onClick: handleMenuOpen,
    onKeyUp: function onKeyUp(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        primaryButtonRef.current.focus();
      }
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        handleMenuOpen(event);
      }
    },
    variant: variant
  }, menuOpen ? mergedDropdownIcons.open : mergedDropdownIcons.closed)), /*#__PURE__*/_react["default"].createElement(_Menu["default"], (0, _extends2["default"])({}, mergedMenuProps, {
    anchorEl: anchorEl,
    open: menuOpen,
    onClose: handleMenuClose
  }), menuItems.map(function (_ref) {
    var label = _ref.label,
      _onClick = _ref.onClick,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], (0, _extends2["default"])({
      key: label,
      onClick: function onClick() {
        return handleMenuItemClick(_onClick);
      }
    }, rest), label);
  })));
});
SplitButton.defaultProps = defaultProps;
SplitButton.displayName = 'SplitButton';
SplitButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The props to pass to the ButtonGroup component. See [MUI ButtonGroup Props](https://v4.mui.com/api/button-group/#props) for more details.
   */
  ButtonGroupProps: _propTypes["default"].shape({
    /**
     * Defines a string value that labels the current element.
     */
    'aria-label': _propTypes["default"].string,
    /**
     * The color of the component. It supports those theme colors that make sense for this component.
     */
    color: _propTypes["default"].oneOf(['inherit', 'primary', 'secondary', 'default']),
    /**
     * If `true`, the buttons will be disabled.
     */
    disabled: _propTypes["default"].bool,
    /**
     * If `true`, no elevation is used.
     */
    disableElevation: _propTypes["default"].bool,
    /**
     * If `true`, the button keyboard focus ripple will be disabled.
     */
    disableFocusRipple: _propTypes["default"].bool,
    /**
     * If `true`, the button ripple effect will be disabled.
     */
    disableRipple: _propTypes["default"].bool,
    /**
     * If `true`, the buttons will take up the full width of its container.
     */
    fullWidth: _propTypes["default"].bool,
    /**
     * The group orientation (layout flow direction).
     */
    orientation: _propTypes["default"].oneOf(['vertical', 'horizontal']),
    /**
     * The group orientation (layout flow direction).
     */
    size: _propTypes["default"].oneOf(['small', 'medium']),
    /**
     * The variant to use.
     */
    variant: _propTypes["default"].oneOf(['outlined', 'contained'])
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * The icon(s) to display on the dropdown button when the menu is open or closed.
   */
  dropdownIcons: _propTypes["default"].shape({
    /**
     * The icon to display when the menu is closed.
     */
    closed: _propTypes["default"].node,
    /**
     * The icon to display when the menu is open.
     */
    open: _propTypes["default"].node
  }),
  /**
   * The MenuItems to display in the dropdown menu. <br>
   *
   * > `label: string | node - required` <br>
   * > `leftIcon: node` <br>
   * > `onClick: func` - **required** <br>
   * > `variant: 'infoText', 'label', 'standard'`,
   */
  menuItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
    leftIcon: _propTypes["default"].node,
    onClick: _propTypes["default"].func.isRequired,
    variant: _propTypes["default"].oneOf(['infoText', 'label', 'standard'])
  })).isRequired,
  /**
   * The props to pass to the Menu component.
   */
  MenuProps: _propTypes["default"].shape({
    /**
     * This controls what side the opened menu aligns itself with the anchor Menu.
     */
    alignment: _propTypes["default"].oneOf(['left', 'right']),
    /**
     * Override or extend the styles applied to the component.
     */
    classes: _propTypes["default"].object,
    /**
     * @ignore
     */
    className: _propTypes["default"].string
  }),
  /**
   * The props to pass to the primary action button.
   *
   * `aria-label: string` <br>
   * `children: string | node` - **required** <br>
   * `icon: node` <br>
   * `onClick: func` - **required** <br>
   */
  primaryButtonProps: _propTypes["default"].shape({
    'aria-label': _propTypes["default"].string,
    children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
    icon: _propTypes["default"].node,
    onClick: _propTypes["default"].func.isRequired
  }).isRequired,
  /**
   * The aria props to pass the secondary button
   *
   * `aria-controls: string` <br>
   * `aria-expanded: bool | "true" | "false" ` <br>
   * `aria-haspopup: "true" | "false" | "menu" | "listbox" | "tree" | "grid" | "dialog" ` <br>
   * `aria-label: string`
   */
  secondaryButtonAriaProps: _propTypes["default"].shape({
    'aria-controls': _propTypes["default"].string,
    'aria-expanded': _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['false', 'true'])]),
    'aria-haspopup': _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['false', 'true', 'menu', 'listbox', 'tree', 'grid', 'dialog'])]),
    'aria-label': _propTypes["default"].string
  }),
  /**
   * The style of the component.
   */
  status: _propTypes["default"].oneOf(['ok'])
} : {};
var _default = SplitButton;
exports["default"] = _default;